import styled from 'styled-components';

export const RewardRow = styled.div`
  display: flex;
  color: ${Styles.color.validated};
`;
